import { setupCrudApiFactory } from '@thyme/libs/src/api/crud'
import { apiRequest } from './api'
import { thymeboxDefaultHeaders } from './headers'

/**
 * Thymebox's CRUD API factory configured with app-specific defaults.
 * Use this to create CRUD APIs for resources with standard operations.
 *
 * For example, in your feature's store file:
 * const goalApi = createCrudApi<Goal, 'goalId'>('/api/goals')
 *
 * See packages/libs/src/api/CRUD_README.md for full documentation.
 */
export const createCrudApi = setupCrudApiFactory(apiRequest, {
  defaultOptions: {
    headers: thymeboxDefaultHeaders,
  },
})
